




























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { UserViewModel, UserService } from '../../api/user';

@Component({})
export default class UserRegister extends Vue {
  private service: UserService = new UserService();
  private data: UserViewModel = this.service.NewModel;
  private rules = {
    registerCode: [
      {required: true, message: '请输入注册码', trigger: 'blur'},
      {len: 6, message: '请输入6位注册码', trigger: 'blur'},
    ],
    realName: [{required: true, message: '请输入姓名', trigger: 'blur'}],
    phoneNumber: [
      {required: true, message: '请输入手机号', trigger: 'blur'},
      {len: 11, message: '请输入11位手机号', trigger: 'blur'},
      {pattern: '^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$', message: '请输入正确的中国手机号', trigger: 'blur'},
    ],
    password: [
      {required: true, message: '请输入密码', trigger: 'blur'},
      {min: 6, message: '请输入不少于6位的密码', trigger: 'blur'},
    ],
    passwordc: [
      {required: true, message: '请输入确定密码', trigger: 'blur'},
      {validator: this.validatePass2, trigger: 'blur'},
    ],
  };
  private validatePass2(rule: any, value: any, callback: any) {
    if (value === '') {
      callback(new Error('请再次输入密码'));
    } else if (value !== this.data.password) {
      callback(new Error('两次输入密码不一致!'));
    } else {
      callback();
    }
  }
  private btnRegister_OnClick() {
    const validate = this.$refs['edit-form'] as any;
    validate.validate((valid: any) => {
      if (valid) {
        this.service.Register(this.data).then((response: any) => {
          this.OnSaved(response);
        });
      }
    });
  }
  @Emit('OnSaved')
  private OnSaved(user: any) {
    return user;
  }
  @Emit('OnCancel')
  private btnCancel_OnClick() {
  }
}
